export const isFullStatic = false
export const staticPath = "/home/hhip/hhip.com/httpdocs/build/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"